import { filterObjectStore, queryFilter } from 'Redux/Query';

export const getSingleEncryptPseudonyms = (state, filter = null) => {
    if(filter === null) {
        filter = queryFilter({sorting: { by: 'createdAt', order: 'DESC' }})
    }

    return filterObjectStore(state.encryptPseudonym.encryptSinglePseudonyms.entries, filter);
};
